module.exports = __webpack_public_path__ + "static/media/Week10.ad0a6e66.pdf";